(() => {
  if (window.__aaaProductSalesLoaded) return;
  window.__aaaProductSalesLoaded = true;

  const countdownTimers = new WeakMap();

  function initCountdown(root = document) {
    root.querySelectorAll('[data-aaa-countdown]').forEach((row) => {
      if (countdownTimers.has(row)) return;
      const output = row.querySelector('[data-aaa-countdown-value]');
      const endRaw = row.getAttribute('data-end');
      const end = endRaw ? new Date(endRaw) : null;
      if (!output || !end || Number.isNaN(end.getTime())) {
        row.hidden = true;
        return;
      }

      const tick = () => {
        if (!document.documentElement.contains(row)) {
          const oldTimer = countdownTimers.get(row);
          if (oldTimer) clearInterval(oldTimer);
          countdownTimers.delete(row);
          return;
        }
        const diff = end.getTime() - Date.now();
        if (diff <= 0) {
          row.hidden = true;
          const timer = countdownTimers.get(row);
          if (timer) clearInterval(timer);
          countdownTimers.delete(row);
          return;
        }
        const totalSeconds = Math.floor(diff / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        output.textContent = days > 0
          ? `${days}d ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
          : `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      };
      tick();
      const timer = setInterval(tick, 1000);
      countdownTimers.set(row, timer);
    });
  }

  function refreshAAAFromVariant(event) {
    const detail = event && event.detail;
    const html = detail && detail.data && detail.data.html;
    const productId = detail && detail.data && String(detail.data.productId || '');
    if (!html || !productId) return;

    document.querySelectorAll('[data-aaa-variant-refresh]').forEach((current) => {
      if (String(current.dataset.productId || '') !== productId || !current.id) return;
      const replacement = html.getElementById(current.id);
      if (!replacement) return;
      const clone = replacement.cloneNode(true);
      current.replaceWith(clone);
      initCountdown(clone.parentElement || document);
    });
  }

  initCountdown(document);
  document.addEventListener('variant:update', refreshAAAFromVariant);
  document.addEventListener('shopify:section:load', (event) => initCountdown(event.target || document));
})();
